import { Table } from '../../../../components/general/table';
import { usePqrHistoryList } from './hook';
import { PqrHistoryListProps } from './props';

export const PqrHistoryList = ({ filters }: PqrHistoryListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrHistoryList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
        />
    );
};
